export const API_PATH = 'https://support-api.aws.dblabs.net';
export const MODAL_ADD = 'modal_add';
export const MODAL_EDIT = 'modal_edit';


// WEBPACK FOOTER //
// ./src/appConstants.js